import React from 'react';
export function EditorAlignRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M22 5H10v2h12V5zm0 4H2v2h20V9zm-12 4h12v2H10v-2zm12 4H2v2h20v-2z"
  }));
}